export const environment = {
  production: false,
  apiUrl: 'https://devapi.moneyseel.ai',
  firebaseConfig: {
    apiKey: "AIzaSyBk55QosiXQkdQ84mSK5OihIP5iBoQvt20",
    authDomain: "esmacs-7d407.firebaseapp.com",
    projectId: "esmacs-7d407",
    storageBucket: "esmacs-7d407.appspot.com", // <- fixed typo here
    messagingSenderId: "410320847166",
    appId: "1:410320847166:web:6e79dc586a0f4a813eac6f",
    measurementId: "G-SBBGE81DKH",
    vapidKey: "BN4qy4Fzj3KaSZk5Zaq1g8uixNF_pr04qsL8ygiiLLAS0mQS4KWYcDyelYsjcC-ZkzQf_Xd6UzUWI1GtUALpcwI" // 🔑 Go to Firebase > Cloud Messaging > Generate Key Pair
  }
};
